import { QaroniCache } from '@qaroni-core/types/qaroni-cache/qaroni-cache';
import { Employee } from './employee';

export class EmployeeCache extends QaroniCache<Employee> {
  public canReturn(companyID: number, employeeID: number): boolean {
    return this.get() &&
      Number.isInteger(companyID) &&
      Number.isInteger(employeeID) &&
      this.get().companyId === companyID &&
      this.get().employeeId === employeeID
      ? true
      : false;
  }

  public canApi(companyID: number, employeeID: number): boolean {
    return !this.canReturn(companyID, employeeID) && !this.flying
      ? true
      : false;
  }
}
